import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { useSelector } from 'react-redux';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Card,
  Grid,
  Typography,
  LinearProgress,
  Icon,
} from '@material-ui/core';
import clsx from 'clsx';


const useStyles = makeStyles(() => ({
  category: {
    cursor: 'pointer',
  }
}));

const MetadataFilter = ({ loading, error, onFilterSelect }) => {
  const classes = useStyles();
  const metadataTypes = ['events', 'general', 'manufacturers'];
  const [selectedType, setSelectedType] = React.useState(false);
  const [selectedMetadata, setSelectedMetadata] = React.useState({});
  const {metadata} = useSelector((state) => state.promo);

  const handleSelectMetadata = (type, label) => {
    if (selectedMetadata._id === label._id) {
      setSelectedMetadata({});
      onFilterSelect({type, meta: {}});
    } else {
      setSelectedMetadata(label);
      onFilterSelect({ type, meta: label });
    }
  };

  return (
    <Grid item md={3} xs={12} className="pb-4">
      {loading && !error && <LinearProgress className="mx-10" />}
      {!loading && !error &&
      <Card className="ml-10 px-2">
        <h4 className={clsx('mx-2 my-4', classes.category)}>Filter</h4>
        {metadataTypes.map((type, idx) => {
          return (
            <Accordion key={idx} expanded={selectedType === type} onChange={() => setSelectedType(type)}>
              <AccordionSummary expandIcon={<Icon>expand_more</Icon>} id={idx}>
                <h5 className="m-0 capitalize">{type}</h5>
              </AccordionSummary>
              <AccordionDetails>
                <ul>
                  {metadata && metadata[type] && metadata[type].map((label) => {
                    return (
                      <Typography className={label._id === selectedMetadata._id ? 'pb-2 font-bold' : 'pb-2'} variant="a" component="p" key={label._id} onClick={() => handleSelectMetadata(type, label)}>{label.label}</Typography>
                    );
                  })}
                </ul>
              </AccordionDetails>
            </Accordion>
          );
        })}
      </Card>
      }
    </Grid>
  );
};

export default MetadataFilter;
